import {useTraduire} from '../i18n/langue';
import {T} from '../i18n/textes';
// Formatting toolbar for Markdown text input

interface FormattingToolbarProps {
  textareaRef: React.RefObject<HTMLTextAreaElement | null>;
  onTextChange: (newText: string) => void;
  getValue: () => string;
}

function insertFormatting(
  textarea: HTMLTextAreaElement,
  prefix: string,
  suffix: string,
  getValue: () => string,
  onTextChange: (text: string) => void,
) {
  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;
  const text = getValue();
  const selected = text.substring(start, end);

  const newText = text.substring(0, start) + prefix + selected + suffix + text.substring(end);
  onTextChange(newText);

  // Restore cursor position after React re-render
  requestAnimationFrame(() => {
    textarea.focus();
    if (selected.length > 0) {
      // Select the formatted text (without markers)
      textarea.setSelectionRange(start + prefix.length, end + prefix.length);
    } else {
      // Place cursor between markers
      textarea.setSelectionRange(start + prefix.length, start + prefix.length);
    }
  });
}

export function FormattingToolbar({textareaRef, onTextChange, getValue}: FormattingToolbarProps) {
    const t = useTraduire();
  return (
    <div className="flex items-center gap-0.5 mb-1">
      <button
        type="button"
        onClick={() => {
          if (textareaRef.current) {
            insertFormatting(textareaRef.current, '**', '**', getValue, onTextChange);
          }
        }}
        className="w-6 h-6 flex items-center justify-center rounded text-xs font-bold text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
        title={t(T.gras)}
      >
        B
      </button>
      <button
        type="button"
        onClick={() => {
          if (textareaRef.current) {
            insertFormatting(textareaRef.current, '*', '*', getValue, onTextChange);
          }
        }}
        className="w-6 h-6 flex items-center justify-center rounded text-xs italic text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
        title={t(T.italique)}
      >
        I
      </button>
      <button
        type="button"
        onClick={() => {
          if (textareaRef.current) {
            insertFormatting(textareaRef.current, '~~', '~~', getValue, onTextChange);
          }
        }}
        className="w-6 h-6 flex items-center justify-center rounded text-xs text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors line-through"
        title={t(T.barre)}
      >
        S
      </button>
      <button
        type="button"
        onClick={() => {
          if (textareaRef.current) {
            insertFormatting(textareaRef.current, '`', '`', getValue, onTextChange);
          }
        }}
        className="w-6 h-6 flex items-center justify-center rounded text-[10px] font-mono text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
        title={t(T.code)}
      >
        {'<>'}
      </button>
    </div>
  );
}
